import type { FC } from 'react';

import InfoIcon from '@/assets/svg/ui-elements/info-circle-outline-gray.svg';

import Tooltip from '../Tooltip';
import { SortIcon } from './SortIcon';
import {
  StyledHeaderCell,
  StyledHeaderLabel,
  StyledHeaderTooltipTrigger,
  StyledSortIconWrapper,
} from './Table.styled';
import { getPinSide } from './Table.utils';
import type { TableHeaderCellProps } from './types';

const TableHeaderCell: FC<TableHeaderCellProps> = ({
  label,
  tooltip,
  align,
  sortable,
  sortDirection,
  onClick,
  pinned,
  anchorEnd,
}) => (
  <StyledHeaderCell
    $align={align}
    $sortable={sortable}
    $pin={getPinSide(pinned)}
    $anchorEnd={anchorEnd}
    onClick={sortable ? onClick : undefined}
    role={sortable ? 'button' : undefined}
    tabIndex={sortable ? 0 : undefined}
    onKeyDown={
      sortable
        ? (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onClick?.();
            }
          }
        : undefined
    }
  >
    <StyledHeaderLabel>{label}</StyledHeaderLabel>
    {tooltip && (
      <Tooltip title={tooltip} side="top" arrow>
        <StyledHeaderTooltipTrigger onClick={(e) => e.stopPropagation()}>
          <InfoIcon width={16} height={16} />
        </StyledHeaderTooltipTrigger>
      </Tooltip>
    )}
    {sortable && (
      <StyledSortIconWrapper $active={sortDirection != null} data-sort-icon>
        <SortIcon direction={sortDirection ?? null} />
      </StyledSortIconWrapper>
    )}
  </StyledHeaderCell>
);

export { TableHeaderCell };
